import Typography, { ETypo, ETypoColor } from "@Front/Components/DesignSystem/Typography";
import StepEmailForm from "./StepEmailForm";
import classes from "../classes.module.scss";
import { ValidationError } from "class-validator";

type StepEmailClientSectionProps = {
	title: string;
	onSubmit: (e: React.FormEvent<HTMLFormElement> | null, values: { [key: string]: string }) => void;
	validationErrors: ValidationError[];
	prefilledEmail: string;
	emailPlaceholder: string;
	emailLabel: string;
	submitCta: string;
};

export default function StepEmailClientSection({
	title,
	onSubmit,
	validationErrors,
	prefilledEmail,
	emailPlaceholder,
	emailLabel,
	submitCta,
}: StepEmailClientSectionProps): React.JSX.Element {
	return (
		<div className={classes["section"]}>
			<Typography typo={ETypo.TITLE_H6} color={ETypoColor.TEXT_ACCENT} className={classes["section-title"]}>
				{title}
			</Typography>
			<StepEmailForm
				onSubmit={onSubmit}
				validationErrors={validationErrors}
				prefilledEmail={prefilledEmail}
				emailPlaceholder={emailPlaceholder}
				emailLabel={emailLabel}
				submitCta={submitCta}
				classes={classes}
			/>
		</div>
	);
}
